'use client'

import MainSlider, { type MainSliderNews } from '@/components/MainSlider'

interface HomeMastheadCenterProps {
  news: MainSliderNews[]
  className?: string
  /** Masaüstü: 9:5 oran + numaralar absolute altta */
  fill?: boolean
  /** Ana sayfa LCP manşeti */
  lcpPriority?: boolean
  /** Desktop kaynak seçimi — konteyner genişliği bilinen kullanımda geç */
  imageSizes?: string
}

export default function HomeMastheadCenter({
  news,
  className = '',
  fill = false,
  lcpPriority = false,
  imageSizes,
}: HomeMastheadCenterProps) {
  const items = news.filter((item) => item.imageUrl?.trim())
  if (items.length === 0) return null

  return (
    <div className={`min-h-0 w-full ${className}`}>
      <MainSlider
        news={items}
        size="compact"
        accent="red"
        pagination="bars"
        lcpPriority={lcpPriority}
        imageSizes={imageSizes}
        className={fill ? 'main-slider-wrap--fill' : ''}
      />
    </div>
  )
}
